import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    getState, findMatchEndMode, getFixturesToPrintForMatches,
} from "../../helper";
import {
    getTeamDeadlineObj,
    getWildCardStatus,
    getBoosterStatus,
    getMatchTimeObj,
} from "../../helper-common";
import {
    getUserSpecificFixtures,
} from './../../actions/ManageTeamActions';
import config from './../../config';
import common from './../../common';
import { findIndex } from 'lodash';

class MatchdayStatus extends Component {
    handleNext = () => {
    };

    createFixtureGroups = () => {
        const { fixtures } = this.props;
        if (fixtures.length) {


            const userSpecificFixtures = getFixturesToPrintForMatches(fixtures);
            const defaultIndex = findIndex(userSpecificFixtures, { selected: true });
            const selectedGameDay = userSpecificFixtures[defaultIndex];
            const gameday = selectedGameDay;
            const { trans, constraints } = this.props;
            let obj = {
                group: {},
                lockTime: ''
            };
            for (let i = 0; i < gameday.Match.length; i++) {
                let match = gameday.Match[i];
                let MDNo = match.MDNo;
                if (!obj.group[MDNo]) {
                    // match.DateTime = '2018-08-08 20:45';
                    obj.group[MDNo] = {
                        date: getMatchTimeObj(match.DateTime, trans, constraints.OffSet),
                        subsWindow: {
                            isAvailable: false
                        },
                        matches: [],
                        livesetMatches: selectedGameDay.MatchDay == MDNo && selectedGameDay.MdIsCurr == 1 ? true : false,
                    };
                    if (match.TeamSc) {
                        obj.group[MDNo]["subsWindow"]["isAvailable"] = (match.TeamSc === "UT_SUB");
                        obj.group[MDNo]["subsWindow"]["TeamScStartDate"] = match.TeamScStartDate;
                        obj.group[MDNo]["subsWindow"]["TeamScEndDate"] = match.TeamScEndDate;
                        if (match.TeamSc === "UT_TRF") {
                            obj.lockTime = match.TeamScEndDate;
                        }
                    }
                }
                obj.group[MDNo].matches.push(match);
            }

            var matchLength = "";
            for (var property in obj.group) {
                if (obj.group.hasOwnProperty(property)) {
                    // Do things here
                    if (obj.group[property].livesetMatches) {
                        matchLength = obj.group[property].matches.length
                    }
                }
            }

            return matchLength;
        }
    };

    render() {
        const { trans, livePoints, teamData, constraints } = this.props;
        const { GDPoints, IsAutoPlay } = teamData;
        const getViewState = this.props.viewState;
        /* autoplay flag */
        let showPtsInfo = common.isManageTeam() && (getViewState);
        let showDeadlineInfo = !(getViewState && getViewState === config.possibleActions["viewpoint"]);
        let hasAutoSubs = false;
        let isAutoSubsOn = false;
        /* if booster taken */
        let boosterInfo = null;
        const showBoosterStatus = (getViewState && getViewState === config.possibleActions["viewpoint"]);
        if (showBoosterStatus && Object.keys(teamData).length > 0) {
            const { userSpecificFixtures, currentActiveFixture } = this.props;
            const currentFixture = userSpecificFixtures[(currentActiveFixture || 0)];
            if (currentFixture) {
                const { GDID } = currentFixture;
                const wildCardStatus = getWildCardStatus(teamData, GDID);
                const limitlessStatus = getBoosterStatus(teamData, GDID);
                const isWildCardUsed = (wildCardStatus === config.wildCardStatus["usedInCurrent"]);
                const isLimitlessUsed = (limitlessStatus === config.limitlessBoosterStatus["usedInCurrent"]);
                if (isWildCardUsed) {
                    boosterInfo = <div className="si-booster-wrap">
                        <div className="si-booster">
                            <i className="icon-ucl-wildcard"></i>
                            <span>{trans.wildcard}</span>
                        </div>
                    </div>
                } else if (isLimitlessUsed) {
                    boosterInfo = <div className="si-booster-wrap">
                        <div className="si-booster">
                            <i className="icon-ucl-limitless"></i>
                            <span>{trans.limitless}</span>
                        </div>
                    </div>
                }
            }
        }
        if (IsAutoPlay === 1 || IsAutoPlay === '1') {
            hasAutoSubs = true;
            isAutoSubsOn = true;
        } else if (IsAutoPlay === 0 || IsAutoPlay === '0') {
            hasAutoSubs = true;
        }
        /* Deadline text */
        let deadlineObj = {};
        const lockTime = this.props.deadline;
        if (lockTime) {
            deadlineObj = getTeamDeadlineObj(trans, constraints.OffSet, lockTime);
        } else {
            const { userSpecificFixtures, currentActiveFixture } = this.props;
            const currentFixture = userSpecificFixtures[(currentActiveFixture || 0)];
            let getViewState = "";
            if (currentFixture) {
                getViewState = getState(currentFixture);
                deadlineObj = getTeamDeadlineObj(trans, constraints.OffSet, currentFixture.Deadline, getViewState);
            }
        }
        let matchdayPoints = GDPoints;
        const showTeamPoints = !(matchdayPoints === undefined || matchdayPoints === null || matchdayPoints === '');
        if (getViewState === config.possibleActions["live"]) {
            matchdayPoints = livePoints ? livePoints : 0;
        }
        let showThis = this.props.manageTeamMode === config.modes["view-manage-team"];
        let mdInfoClass = common.makeClasses({
            'si-md-info': true,
            'si-post-md-info': boosterInfo
        })
        let fixturesGroup = this.createFixtureGroups();
        let matchEndMode = findMatchEndMode(this.props.liveScore, fixturesGroup)
        return ((getViewState === config.possibleActions["live"]) ?
            (
                <React.Fragment>
                    {
                        matchEndMode
                            ?
                            (<div className="si-md-info">
                                <div className="si-pts-info si-flexBox">

                                    <div className="si-md-pts">
                                        <span className="si-md-num">{matchdayPoints}</span>
                                        <span className="si-md-txt">{trans.MDPoints || "Matchday points"}</span>
                                    </div>

                                    <div className="si-pts-loader">
                                        <div className="si-loader-wrap">
                                            <div className="si-loader">
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                            </div>
                                        </div>
                                        <div className="si-pts-loader-txt">{trans.calcInProg || "Calculation in progress"}</div>
                                    </div>
                                    <div className="si-lock-icon">
                                        <i className="icon-ucl-lock" />
                                    </div>
                                </div>
                            </div>)
                            :
                            (<div className="si-md-info si-live-info">
                                <div className="si-pts-info si-flexBox">
                                    <div className="si-md-pts">
                                        <span className="si-md-num">{matchdayPoints} </span>
                                        <div className="si-md-txt">
                                            <div className="si-live-anim">{trans.live}<span /></div>
                                            <div>{trans.points}</div>
                                        </div>
                                    </div>
                                    <div className="si-lock-icon">
                                        <i className="icon-ucl-lock" />
                                    </div>
                                </div>
                            </div>)
                    }
                </React.Fragment>
            )
            :
            (showThis ? <div className={mdInfoClass}>
                {showDeadlineInfo ? <div className="si-subs-status">
                    {deadlineObj.isLockIcon ? <i className="icon-ucl-lock" /> : null}
                    {deadlineObj.deadlineText ? deadlineObj.deadlineText : null}
                </div> : null}
                {showPtsInfo ? <div className="si-pts-info si-flexBox">
                    <div className="si-md-pts">
                        {
                            showTeamPoints ?
                                <React.Fragment>
                                    <span className="si-md-num">{matchdayPoints}</span>
                                    <span className="si-md-txt">{trans.MDPoints}</span>
                                </React.Fragment> :
                                null
                        }
                    </div>
                    {boosterInfo}
                    {hasAutoSubs ? <div className="si-auto-subs">
                        <span>{trans.autoSubs}:</span>
                        <span className="si-status-switch">{isAutoSubsOn ? trans.on : trans.off}</span>
                    </div> : null}
                </div> : null}
            </div> : null)
        )
    }
}

const mapStateToProps = (state) => {
    return {
        constraints: state.appData.constraints,
        trans: state.appData.trans,
        userSpecificFixtures: state.formationData.userSpecificFixtures,
        currentActiveFixture: state.formationData.currentActiveFixture,
        teamData: state.formationData.teamData,
        fixtures: state.formationData.fixtures,
        userPlayedMatchDays: state.formationData.userPlayedMatchDays,
        manageTeamMode: state.formationData.manageTeamMode,
        liveScore: state.formationData.liveScore.response,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getUserSpecificFixtures: () => dispatch(getUserSpecificFixtures()),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(MatchdayStatus);


// WEBPACK FOOTER //
// ./src/components/manage-team/Matchday-Status.js